var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrderInWarehouseProcess = function SvgOrderInWarehouseProcess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 20h2.5v-9h13v9H21V7.5L12 4 3 7.5V20Zm-2 2V6.545L12 2l10.91 4.545L23 22h-6.5v-9h-9v9H1Zm7.5-1.5v-2h2v2h-2ZM11 17v-2h2v2h-2Zm2.5 3.5v-2h2v2h-2Z",
    fill: "#000",
    fillOpacity: 0.87
  })));
};
export default SvgOrderInWarehouseProcess;